.pill {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 9999px;
  background-color: #f2f2f2;
}

.option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  transition: background-color 150ms ease;
}

.optionActive {
  background-color: #e8ebf7;
}

.pill {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 9999px;
  background-color: #f2f2f2;
}

.option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  transition: background-color 150ms ease;
}

.optionActive {
  background-color: #e8ebf7;
}

[data-mantine-color-scheme="dark"] .complex {
  background-color: #1f1f1f;
}

[data-mantine-color-scheme="dark"] .complex .optionActive {
  background-color: var(--mantine-color-secondary-4);
}

.pill {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 9999px;
  background-color: var(--mantine-color-primaryDark-1);
}

.option {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  transition: background-color 150ms ease;
}

.optionActive {
  background-color: var(--mantine-color-primary-0);
}

[data-mantine-color-scheme="dark"] .complex {
  background-color: #1f1f1f;
}

[data-mantine-color-scheme="dark"] .complex .optionActive {
  background-color: #383838;
}
